'use client';

import { c as _c } from "react/compiler-runtime";
import { ProductInfoSkeleton } from '@/modules/service-purchase/components/product-info';
import { StepsTriggerListSkeleton } from '@/modules/service-purchase/components/service-purchase-wizard/steps-trigger';
import { ServicePurchaseStep } from '@/modules/service-purchase/types';
import { ServiceInfoSkeleton } from '@/modules/services/components/service-info';
import { PageContent } from '@/modules/shared/components/page-containers';
function PurchaseLoadingFallbackSkeleton() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <StepsTriggerListSkeleton activeStep={ServicePurchaseStep.ProductInfo} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-4 sm:flex-row sm:items-center"><div className="min-w-0 flex-1"><ServiceInfoSkeleton showSelectOperatorAction={true} /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PageContent className="gap-6" aria-busy="true"><div className="flex flex-col gap-6 lg:gap-8"><div className="flex w-full flex-col gap-8">{t0}{t1}<div className="m-0 flex flex-col gap-2"><ProductInfoSkeleton /></div></div></div></PageContent>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export { PurchaseLoadingFallbackSkeleton };